<template>
  <b-form-group
    label="Görünüm"
    label-for="id_corporate_policies_type"
  >
    <validation-provider
      #default="{ errors }"
      name="Görünüm"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_corporate_policies_type"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Giriniz"
        @input="switchType()"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'CorporatePoliciesTypeCard',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['corporatePoliciesType/dataList']
    },
    dataItem() {
      return this.$store.getters['corporatePolicies/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('corporatePoliciesType/getDataList', {
        select: [
          'corporate_policies_type.id AS id',
          'corporate_policies_type.title AS title',
          'corporate_policies_type.form_component AS form_component',
        ],
      })
    },
    switchType() {
      if (this.dataItem.id_corporate_policies_type !== '1') {
        this.dataItem.is_homepage = '0'
      }
    },
  },
}
</script>
